if (!customElements.get('pb-exchange-notice')) {
  customElements.define('pb-exchange-notice', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const details = this.querySelector('details');
      const trigger = this.querySelector('button');
      const fallback = this.querySelector('[data-pb-exchange-fallback]');
      const summary = this.querySelector('summary');
      if (!details || !trigger || !fallback || !summary) return;
      this.initialized = true;

      const syncExpanded = () => {
        trigger.setAttribute('aria-expanded', String(details.open));
        if (summary.hasAttribute('aria-expanded')) {
          summary.setAttribute('aria-expanded', String(details.open));
        }
      };
      trigger.addEventListener('click', () => {
        details.open = true;
        syncExpanded();
        summary.focus({ preventScroll: true });
      });
      details.addEventListener('toggle', syncExpanded);
      syncExpanded();
      fallback.hidden = true;
      trigger.hidden = false;
    }
  });
}
